import type { LandingComponents } from "@/puck/blocks/blockTypes";
import { iconPickerField } from "@/puck/fields/iconPickerField";
import { FloatingBadgeBlock } from "@/puck/landing/floatingBadgeBlock";

const BADGE_ICON_OPTIONS = [
  { label: "PDF document", value: "file-pdf" },
  { label: "Upload", value: "upload" },
  { label: "Cloud upload", value: "cloud-arrow-up" },
  { label: "Document", value: "file-lines" },
  { label: "Approved document", value: "file-circle-check" },
];

export const badgeConfigs: Pick<LandingComponents, "FloatingBadge"> = {
  FloatingBadge: {
    label: "Floating badge",
    fields: {
      variant: {
        type: "radio",
        label: "Style",
        options: [
          { label: "Badge", value: "badge" },
          { label: "Pill", value: "pill" },
        ],
      },
      icon: iconPickerField("Icon", BADGE_ICON_OPTIONS),
      title: { type: "text", contentEditable: true },
      status: { type: "text", contentEditable: true },
      angle: {
        type: "select",
        label: "Rotation",
        options: [
          { label: "Slight left (-3°)", value: "-3" },
          { label: "Left (-2°)", value: "-2" },
          { label: "None", value: "0" },
          { label: "Right (2°)", value: "2" },
          { label: "Slight right (3°)", value: "3" },
        ],
      },
      layout: {
        type: "radio",
        label: "Layout",
        options: [
          { label: "Inline", value: "inline" },
          { label: "Overlapping (float over adjacent content)", value: "overlapping" },
        ],
      },
      placement: {
        type: "radio",
        label: "Overlap direction",
        options: [
          { label: "Float over content below", value: "top" },
          { label: "Float over content above", value: "bottom" },
        ],
      },
      align: {
        type: "radio",
        label: "Alignment",
        options: [
          { label: "Left", value: "left" },
          { label: "Right", value: "right" },
        ],
      },
      overlapMargin: {
        type: "number",
        label: "Overlap offset (px)",
        min: 0,
      },
    },
    defaultProps: {
      variant: "badge",
      icon: "file-pdf",
      title: "UnderwritingGuide.pdf",
      status: "Indexed · ready to ask",
      angle: "-2",
      layout: "overlapping",
      placement: "bottom",
      align: "left",
      overlapMargin: 40,
    },
    render: FloatingBadgeBlock,
  },
};
